<template>
    <!--  newsletter Section -->
    <newsletter></newsletter>
    <!--  End newsletter Section -->
    <footer class="main-footer">

        <div class="widget-section p_relative pt_100 ">
            <div class="auto-container">



                <div class="footer-widget-area ">
                    <div class="row">
                        <div class="col-xl-5 col-lg-3 col-md-12">
                            <div class="footer-widget about-company-widget mb-40 wow fadeInDown">
                                <router-link :to="{ name: 'HomePage'}" class="footer-logo">
                                    <img :src="companyLogo" :alt="companyName">
                                </router-link>
                                <p>
                                    {{FooterLogoDescription}}
                                </p>
                                <SocialMediaIconComponent></SocialMediaIconComponent>
                            </div>
                        </div>
                        <div class="col-lg-1 col-md-6 col-sm-12 footer-column"></div>
                            <div class="col-lg-2 col-md-6 col-sm-12 footer-column">
                                <div class="footer-widget links-widget">
                                    <div class="widget-title">
                                        <h3>About</h3>
                                    </div>
                                    <div class="widget-content">
                                        <ul class="links-list clearfix">
                                            <li><a href="about.html">About Company</a></li>
                                            <li><a href="contact.html">Contact us</a></li>
                                            <li><a href="#">Become Host</a></li>
                                            <li><a href="#">Associations</a></li>
                                            <li><a href="#">Media News</a></li>
                                            <li><a href="#">Travel Guide</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-2 col-md-6 col-sm-12 footer-column">
                                <div class="footer-widget links-widget">
                                    <div class="widget-title">
                                        <h3>Top Cities</h3>
                                    </div>
                                    <div class="widget-content">
                                        <ul class="links-list clearfix">
                                            <li><a href="#">London</a></li>
                                            <li><a href="#">Dubai</a></li>
                                            <li><a href="#">California</a></li>
                                            <li><a href="#">Tokyo</a></li>
                                            <li><a href="#">Las Vegas</a></li>
                                            <li><a href="#">New York City</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-2 col-md-6 col-sm-12 footer-column">
                                <div class="footer-widget links-widget">
                                    <div class="widget-title">
                                        <h3>Top Countries</h3>
                                    </div>
                                    <div class="widget-content">
                                        <ul class="links-list clearfix">
                                            <li><a href="#">United State</a></li>
                                            <li><a href="#">Belgium</a></li>
                                            <li><a href="#">Germany</a></li>
                                            <li><a href="#">United Kingdom</a></li>
                                            <li><a href="#">Mexico</a></li>
                                            <li><a href="#">Argentina</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <!--<div class="col-xl-2 col-lg-3 col-md-4">
            <div class="footer-widget footer-nav-widget pl-lg-20 mb-40 wow fadeInDown">
                <h4 class="widget-title">Services</h4>
                <div class="footer-nav-content">
                    <ul class="footer-nav">
                        <li class="item-list-a" v-for="serviceLink in serviceLinks">
                            <router-link :to="{ name: serviceLink.routeUrl}">{{serviceLink.displayText}}</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>-->


                        </div>
                    </div>


                <!--=== Copyright Area ===-->
                <div class="copyright-area">
                    <div class="row">
                        <div class="col-lg-12 text-center">
                            <div class="copyright-text">
                                <p v-html="Copyrights"></p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </footer>
    <a href="#" class="back-to-top" :style="(show)?ShowCss:hideCss"><i class="fa fa-angle-up"></i></a>
</template>

<script>
    import newsletter from '@/views/NewsLetter/newsletter.vue'
    import SocialMediaIconComponent from '@/views/SocialMediaIcons/socialMediaIcons.vue'
    export default {
        name: 'FooterVue',
        props: ["footerNavLinks", "serviceLinks", "FooterLogoDescription", "OurAddress", "OurEmail", "OurPhone", "Copyrights"],
        components: {
            newsletter,
            SocialMediaIconComponent
        },
        data() {
            let currentYear = new Date().getFullYear();

            return {

                show: false,
                currentYear,
                companyLogo: '',
                companyName: '',
                hideCss:{
                    display:'none'
                    },
                
                ShowCss:{
                    display:'inline'
                    },
            }
        },
        created() {
            this.getCompanyLogo();
            this.companyName = localStorage.getItem('companyName')
        },
         mounted() {
            window.addEventListener('scroll', this.updateScroll);
        },
        methods: {
            getCompanyLogo() {
                let logoUrl = localStorage.getItem('companyLogo');
                this.companyLogo = (this.$filters.IsNull(logoUrl, 'null') == 'null') ? require('../../../../../assets/images/logo/default-logo.png') : logoUrl;
            },
            updateScroll() {
                let windoWidth = window.scrollY;
                if (windoWidth > 500) {
                    this.show = true;
                } else {
                    this.show = false;
                }
            }

        }

    }
</script>